<div class="container">
    <div class="row">
        <div class="col mt-2">
            <h4> Volunteer In Compliance Report</h4>
        </div>
    </div>
    <div class="d-flex flex-row sub-title-text mt-2 mb-2">
        <b class="me-2">Search:</b> {{getSearchCriteria()}}
    </div>
    <div class="d-flex flex-row sub-title-text mt-2 mb-2">
        <b class="me-2">Item Packet:</b> {{getItemPacketLabel()}}
    </div>
    <div class="d-flex flex-row sub-title-text mt-2 mb-2">
        <b class="me-2">Volunteer Areas:</b> {{ getVolunteerAreasLabel() }}
    </div>
    <div>
        <table class="print-table table outer-table">
            <caption class="visually-hidden">Volunteer in compliance report showing name, item packets, and volunteer areas</caption>
            <thead>
                <tr>
                    <th scope="col" class="fit no-wrap">Name</th>
                    <th scope="col" class="no-wrap">Item Packets</th>
                    <!-- <th scope="col" class="no-wrap">In Compliance Until</th> -->
                    <th scope="col" class="no-wrap">Volunteer Areas</th>
                </tr>
            </thead>
            <tbody *ngFor="let entry of pagedResponse.Results">
                <tr>
                    <td>{{entry.Name}} <br /> <span style="font-size: 1em;">{{entry.Email}}</span></td>
                    <td>
                        <item-packet-pill [pill]="getItemPacket(entry.ItemPacketId).Pill" [showStatusStamp]="true"
                            [status]="getInComplianceStatus(entry.IsInCompliance)"></item-packet-pill>
                        <!-- <span *ngIf="entry.IsExpiringSoon" class="ms-2 badge bg-warning">Expiring Soon</span> -->
                    </td>
                    <!-- <td>{{entry.EndDate | date: 'MM/dd/yyyy'}}</td> -->
                    <td>{{entry.VolunteerAreas}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>